export enum DataSecuritySensitivityLabelPlatform {
	SharePoint = 'sharepoint',
	Teams = 'teams',
	MicrosoftGroups = 'group',
	PowerBI = 'powerbi-workspace',
	Engage = 'engage'
}

export interface DataSecurity {
	sensitivityLabel: DataSecuritySensitivityLabelStats;
	retentionLabels?: DataSecurityRetentionLabel[];
}

export interface DataSecurityRetentionLabel {
	name:string;
	usageCount:number;
	usageCountConverted?:string;
}

export interface DataSecuritySensitivityLabelStats {
	notApplied: number;
	notAppliedByPlatform: DataSecurityPlatformLabelCountExtraInfo[];
}

export interface DataSecurityPlatformLabelCount {
	platform: DataSecuritySensitivityLabelPlatform;
	count: number;
	countConverted?: string;
	countTooltip?: string;
}

export interface DataSecurityPlatformLabelCountExtraInfo extends DataSecurityPlatformLabelCount {
	label?: string;
	icon?: string;
	order: number;
}

export const DATASECURITYSENSITIVITYLABELINFO: { [platform in DataSecuritySensitivityLabelPlatform]: { label: string; icon: string, order: number }; } =
{
	[DataSecuritySensitivityLabelPlatform.SharePoint]: { label: 'SharePoint', icon: "platform-sharepoint-alt", order: 1 },
	[DataSecuritySensitivityLabelPlatform.Teams]: { label: 'Teams', icon: "platform-teams-alt", order: 2 },
	[DataSecuritySensitivityLabelPlatform.MicrosoftGroups]: { label: 'Microsoft Groups', icon: "platform-microsoft365-groups-alt", order: 3 },
	[DataSecuritySensitivityLabelPlatform.Engage]: { label: 'Engage', icon: "platform-vivaengage-alt", order: 4 },
	[DataSecuritySensitivityLabelPlatform.PowerBI]: { label: 'Power BI', icon: "platform-power-bi-alt", order: 5 },
}

export const DEFAULTSENSITIVITYLABELINFO: DataSecuritySensitivityLabelStats = {
	notApplied: 0,
	notAppliedByPlatform: [
		{
			platform: DataSecuritySensitivityLabelPlatform.SharePoint,
			count: 0,
			order: 1,
		},
		{
			platform: DataSecuritySensitivityLabelPlatform.Teams,
			count: 0,
			order: 2,
		},
		{
			platform: DataSecuritySensitivityLabelPlatform.MicrosoftGroups,
			count: 0,
			order: 3,
		},
		{
			platform: DataSecuritySensitivityLabelPlatform.PowerBI,
			count: 0,
			order: 5,
		}
	]
}